<template>
  <div class="steam-index">
    <app-header class="header" />
    <section v-for="(data, index) in items" :key="`first-${index}`">
      <div class="stem-first">
        <div class="steam-address steam-item steam-item_title" :class="isLogin">
          <p v-if="$store.state.isLogin">
            {{$store.state.userAccount.id}} 
            <br class="sp">
            | BUSD In Your Wallet：{{data.item.yourWallet.bnb}}
          </p>
          <p v-else>
            Please enter your address above…
          </p>
        </div>
        <div class="steam-holdings steam-item">
          <h3>Your STEAM Holdings</h3>
          <p class="steam-item_desc">{{data.item.userHolding.steam}} STEAM</p>
        </div>
        <div class="steam-paid steam-item">
          <h3>Total BNB Paid</h3>
          <p class="steam-item_desc">
            <span>{{data.item.bnbPaidTota.bnbPaid}} BUSD</span> 
          </p>
        </div>
        <div class="steam-payout_time steam-item">
          <h3>Last Payout Time</h3>
          <p class="steam-item_desc">{{data.item.payoutTime.hours}} Hours Ago</p>
        </div>
        <div class="steam-payout_load steam-item">
          <h3>Payout Loading</h3>
          <p class="steam-item_desc">
            <span>{{data.item.payoutLoading.bnb}} BUSD</span>
          </p>
          <p class="steam-item_percent">{{data.item.payoutLoading.percent}}%</p>
        </div>
      </div>
      <div class="steam-btn" :class="isLogin">
        <div v-if="$store.state.isLogin" @click="openModal('steam-claim-modal')" class="steam-btn_gradetion">
          <p>Claim Payout</p>
        </div>
        <div v-else @click="openModal('modal-connect-wallet')" class="steam-btn_gray">
          <button>Connect Wallet and Claim Manually Now</button>
        </div>
        <div v-if="isConfirm" class="steam-btn_gray">
          <p>Payout Claimed！</p>
        </div>        
      </div>      
    </section>
    <section v-for="(data, index) in items" :key="`second-${index}`">
      <div class="steam-second">
        <div class="steam-bnb">
          <figure>
            <img src="@/assets/sf/icon/binance-busd.svg">
          </figure>
          <h3 class="steam-bnb_title">
            Total BNB Paid To TIKI Holders
          </h3>
          <p class="steam-bnb_dsc">
            {{data.item.userHolding.steam}}
            <span>BUSD</span>
          </p>
        </div>
        <div class="steam-volume">
          <p>
            Estimations are based on a default of the last 24h of trading volume<br>
            Change the volume to predict earnings based on other volume figures<br>
            Trading Volume =＄{{data.item.tradingVolume}}
          </p>
        </div>
        <div class="steam-earns steam-contents">
          <figure class="steam-earns_icon">
            <img src="@/assets/sf/image/steam/earn.svg">
          </figure>
          <h3 class="steam-earns_title">
            Your {{data.item.userEarns.total}} STEAM Earns:
          </h3>
          <div class="steam-earns_dsc">
            <ul>
              <li>
                <div class="steam-dsc_left">
                  <span class="strong">{{data.item.userEarns.day.bnb}} BUSD</span>
                </div>
                <div>
                  <span class="m-l">Per Day</span>
                </div>
              </li>
              <li>
                <div class="steam-dsc_left">
                  <span class="strong">{{data.item.userEarns.week.bnb}} BUSD</span>
                </div>
                <div>
                  <span class="m-l">Per Week</span>
                </div>
              </li>
              <li>
                <div class="steam-dsc_left">
                  <span class="strong">{{data.item.userEarns.month.bnb}} BUSD</span>
                </div>
                <div>
                  <span class="m-l">Per Month</span>
                </div>
              </li>
              <li>
                <div class="steam-dsc_left">
                  <span class="strong">{{data.item.userEarns.year.bnb}} BUSD</span>
                </div>
                <div>
                  <span class="m-l">Per Year</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="steam-earns_dsc">
            <p class="b-content">
              Dynamic estimations based on <br>
              trading volume of ${{data.item.tradingVolume}}
            </p>
          </div>
        </div>
        <div class="steam-dividends steam-contents">
          <figure>
            <img src="@/assets/sf/image/steam/dividends.svg">
          </figure>
          <h3>
            By Reinvesting Dividends<br>
            Every Day, Your {{data.item.reinvesting.total}} STEAM<br>
            Becomes:            
          </h3>
          <div class="steam-dividends_dsc">
            <ul>
              <li>
                <div class="steam-dsc_left">
                  <span class="strong">{{data.item.reinvesting.week.steam}} STEAM</span> ({{data.item.reinvesting.week.fold}}x Earnings)
                </div>
                <div>
                  <span class="m-l">In a Week</span>
                </div>
              </li>
              <li>
                <div class="steam-dsc_left">
                  <span class="strong">{{data.item.reinvesting.month.steam}} STEAM</span> ({{data.item.reinvesting.month.fold}}x Earnings) 
                </div>
                <div>
                  <span class="m-l">In a Month</span>
                </div>
                </li>
              <li>
                <div class="steam-dsc_left">
                  <span class="strong">{{data.item.reinvesting.halfyear.steam}} STEAM</span> ({{data.item.reinvesting.halfyear.fold}}x Earnings) 
                </div>
                <div>
                  <span class="m-l">In 6 Months</span>
                </div>
                </li>
              <li>
                <div class="steam-dsc_left">
                  <span class="strong">{{data.item.reinvesting.year.steam}} STEAM</span> ({{data.item.reinvesting.year.fold}}x Earnings) 
                </div>
                <div>
                  <span class="m-l">In 1 Year</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="steam-earns_dsc">
            <p class="b-content">
              Estimations are based on <br>
              current $STEAM price (${{data.item.reinvesting.price}})
            </p>
          </div>          
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import AppHeader from '@/components/organisms/steam/SteamHeader'

  export default {
    name: 'SteamIndex',
    components: {
      AppHeader,
    },
    data() {
      return {
        items: [
          {
            item: {
              yourWallet:{bnb:0.7610},
              userHolding:{steam:"19,440"},
              bnbPaidTota:{bnbPaid:0.0113},
              payoutTime:{hours:2},
              payoutLoading:{bnb:0.004,percent:69},
              tradingVolume: "1,633,956",
              userEarns:{total:"28,852",day:{bnb:0.02},week:{bnb:0.11},month:{bnb:0.47},year:{bnb:5.68}},
              reinvesting:{price:0.0170,total:"28,852",week:{steam:"31,060",fold: 1.08},month:{steam:"39,576",fold: 1.37},halfyear:{steam:"196,276",fold: 6.80},year:{steam:"1,349,375",fold: 46.77}}
            },
          },
        ],
        isConfirm: false
      }
    },
    computed: {
      isLogin(){
        return [{ 'is-login' : this.$store.state.isLogin }]
      },
    },
    methods: {
      openModal(target) {
        this.$store.dispatch('openModal', target)
      }            
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_variables.scss';


  // firstItem
  .steam-index {
    section{
      max-width: 1110px;
      margin: auto;
      @include media(pc) {
        width: 100%;
      }  
      @include media(sp) {
        width: 92%;
      }          
    }
  }
  .stem-first{
    display: grid;
    grid-template: 
    "...... ...... ...... ...... ...... ...... ......" 60px    
    "head   head    head  head   head   head   head" 
    "...... ...... ...... ...... ...... ...... ......" 32px
    "item-1 ...... item-2 ...... item-3 ...... item-4" auto
    "...... ...... ...... ...... ...... ...... ......" 32px
    / 23% 2% 23% 2% 23% 2% 23%;
    @include media(sp) {
      grid-template: 
      "...... ...... ......" 30px    
      "head   head   head" 
      "...... ...... ......" 16px
      "item-1 ...... item-2" auto
      "...... ...... ......" 16px
      "item-3 ...... item-4" auto
      "...... ...... ......" 30px
      / 49% 2% 49%;
    }
  }
  .steam-item{
    padding: 28px 0 20px;
    text-align: center;
    border-radius: 18px;
    box-shadow: 0 0 15px #ccc;
      @include media(sp) {
        padding: 28px 0 20px;
        border-radius: 14px;
        box-shadow: 0 0 6px #ccc;
      }
    &_title{
      padding: 16px 46px;
      font-size: 20px;
      font-weight: 200;
      text-align: left;
      @include media(sp) {
        padding: 20px;
        font-size: 3.2vw;
      }      
    }
    &_desc{
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 20px;
      @include media(sp) {
        font-size: 4.5vw;
      }
      span{
        color: #F3BA2F;
      }
    }
    &_percent{
      font-size: 1vw;
      font-weight: 500;
      @include media(sp) {
        font-size: 3.8vw;
      }
    }
    h3{
      font-size: 16px;
      margin-bottom: 28px;
      @include media(sp) {
        font-size: 3vw;
        margin-bottom: 28px;
      }      
    }
  }
  .steam-address{
    grid-area: head;
    background: var(--color_bg_parts);
    &.is-login{
      background: #AFDCFF;
      color: #fff;
      text-align: center;
      p{
        font-weight: 500;
      }
    }
  }
  .steam-holdings{
    grid-area: item-1;
    background: var(--color_bg_parts);
  }
  .steam-paid{
    grid-area: item-2;
    background: var(--color_bg_parts);
  }
  .steam-payout_time{
    grid-area: item-3;
    background: var(--color_bg_parts);
  }
  .steam-payout_load{
    grid-area: item-4;
    background: var(--color_bg_parts);
  }

  // button
  .steam-btn{
    .steam-btn_gray,.steam-btn_gradetion{
      display: block;
      text-align: center;
      font-weight: 700;
      text-decoration: none;
      position: relative;
      cursor: pointer;
      border: none;
      width: 100%;
      transition: $transition-common;
      padding: 1rem;
      font-size: 20px;
      border-radius: 72px;
      background: #BAB8C0;
      color: $color-font-inverse;
      @include media(sp) {
        font-size: 3.2vw;
        padding: 1.6rem;
      }
    }
    &.is-login{
      .steam-btn_gradetion {
        background: $gradation-vertical;
      }
    }     
  }

  // steam-second
  .steam-second{
    text-align: center;
    display: grid;
    grid-template:
    "...... ...... ......" 40px
    "bnb    bnb    bnb" 
    "...... ...... ......" 40px
    "volume volume volume"
    "...... ...... ......" 40px
    "earns  ...... div" auto
    "...... ...... ......" 100px/48% 3% 48%;
    @include media(sp) {
      grid-template:
      "...... ...... ......" 24px
      "bnb    bnb    bnb" 
      "...... ...... ......" 24px
      "volume volume volume"
      "...... ...... ......" 24px
      "earns earns earns" auto
      "...... ...... ......" 24px
      "div   div   div" auto
      "...... ...... ......" 40px;
    }
    .steam-contents{
      padding: 44px 0 40px;
      text-align: center;
      border-radius: 18px;
      box-shadow: 0 0 15px #ccc;
      @include media(sp) {
        padding: 32px 0;
      }
    }
    .steam-bnb{
      grid-area: bnb;
      background: var(--color_bg_parts);
      padding: 32px 0;
      border-radius: 18px;
      box-shadow: 0 0 15px #ccc;
      @include media(sp) {
        box-shadow: 0 0 6px #ccc;      
        padding: 20px 0;
        border-radius: 12px;
      }
      figure{
        width: 80px;
        height: auto;
        margin: 0 auto 26px;
        @include media(sp) {
          width: 40px;
          margin: 0 auto 16px;
          height: auto;
        }
      }
      &_title{
        font-size: 20px;
        margin-bottom: 8px;
        font-weight: 500;
        @include media(sp) {
          font-size: 3.2vw;
          margin-bottom: 12px;
        }
      }
      &_dsc{
        font-size: 28px;
        @include media(sp) {
          font-size: 4.8vw;
        }
        span{
          color: #F3BA2F;
        }        
      }
    }
    .steam-volume{
      grid-area: volume;
      background: var(--color_bg_parts);
      padding: 40px 0;
      border-radius: 18px;
      box-shadow: 0 0 15px #ccc;
      font-size: 20px;
      font-weight: 500;
      @include media(sp) {
        font-size: 14px;
        padding: 32px 24px;
      }
    }
    .steam-dividends,.steam-earns{
      background: var(--color_bg_parts);
      figure{
        width: 72px;
        margin: 0 auto 24px;
        @include media(sp) {
          width: 14vw;
        }
      }
      h3{
        font-size: 20px;
        @include media(sp) {
          font-size: 15px;
        }
      }
      &_dsc{
        .strong{
          color: #F3BA2F;
        }
        .m-l{
          margin-left: 18px;
          @include media(sp) {
            margin-left: 8px;
          }
        }
        ul{
          width: 100%;
          margin: 0 auto 32px;
          @include media(sp) {
            margin: 0 auto 16px;
          }
          li{
            display: flex;
            justify-content: center;
            margin-bottom: 16px;
            font-size: 16px;
            @include media(sp) {
              margin: 0 auto 10px;
              font-size: 12px;
            }            
          }
        }        
      }
      .b-content{
        font-size: 18px;
        font-weight: 400;
        @include media(sp) {
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
    .steam-earns{
      grid-area: earns;
      figure{
        margin-bottom: 60px;
        @include media(sp) {
          margin-bottom: 40px;
        }
      }      
      h3{
        margin-bottom: 40px;
        @include media(sp) {
          margin-bottom: 24px;
        }
      }
      li{
        div{
          width: 45%;
          text-align: left;
          &.steam-dsc_left{
            width: 40%;
            text-align: right;
          }         
        }
      }     
    }
    .steam-dividends{
      grid-area: div;
      h3{
        margin-bottom: 16px;
      }   
      li{
        div{
          width: 40%;
          text-align: left;
          &.steam-dsc_left{
            width: 60%;
            text-align: right;
            @include media(sp) {
              width: 65%;
            }
          }         
        }
      }
    }
  }
  .sp{
    display: none;
    @include media(sp) {
      display: block;
    }
  }
</style>